import { bindActionCreators } from 'redux'
import { cognitoLoginUser } from '../../../account/actions'

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    cognitoLoginUser,
  },
  dispatch,
)

export default mapDispatchToProps
